import { MessageCircle } from 'lucide-react';
import { Tutee } from '../../../types/tuition';
import ChatModule from '../components/ChatModule';

interface MessagingAdminProps {
  tutees: Tutee[];
  selectedTuteeId: string;
}

const MessagingAdmin = ({ tutees, selectedTuteeId }: MessagingAdminProps) => {
  const selectedTutee = tutees.find((t) => t.id === selectedTuteeId);

  return (
    <div className="p-2 sm:p-4">
      {selectedTutee ? (
        <div className="h-[min(70vh,700px)] min-h-[400px] rounded-[2rem] overflow-hidden border border-indigo-50 bg-white">
          <ChatModule tutee={selectedTutee} role="admin" isInline />
        </div>
      ) : (
        <div className="py-16 text-center bg-gray-50 rounded-[2rem] border-2 border-dashed border-gray-200">
          <MessageCircle className="w-12 h-12 text-indigo-200 mx-auto mb-4" />
          <p className="text-gray-500 font-medium">Choose a tuition group at the top to open their chat.</p>
        </div>
      )}
    </div>
  );
};

export default MessagingAdmin;
